module.exports = __webpack_public_path__ + "static/media/4ODA6.48bd3afa.jpg";